import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

const ProducerRoute = ({ component: Component, auth, ...rest }: any) => {
    return <Route {...rest} render={(props) => {
        return ['producer'].indexOf(auth.user?.role) != -1 ? (
            <Component {...props}/>
        ) : (
                <Redirect to={{ pathname: '/', state: { from: props.location } }} />
            );
    }} />
};

export default connect(({ auth }: any) => ({ auth }))(
    ProducerRoute
);
